import { createFileRoute } from '@tanstack/react-router';

import { PortalOficinaVirtual } from '@/features/portal/portal-oficina-virtual';

export const Route = createFileRoute('/portal/oficina-virtual')({
  component: PortalOficinaVirtual,
});
